import React, { useState, useEffect, useRef } from "react";

import { useDispatch, useSelector, shallowEqual } from "react-redux";

import {
  Table,
  Tooltip,
  Tag,
  Form,
  Input,
  Button,
  Space,
  Modal,
  Descriptions,
  Divider,
  Statistic,
  Col,
  Popconfirm,
  Collapse,
  Select,
  DatePicker,
  Switch,
  TimePicker,
  Checkbox,
  message,
} from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  VideoCameraOutlined,
  UploadOutlined,
  DeploymentUnitOutlined,
  SearchOutlined,
  EditOutlined,
  PlusOutlined,
  SaveOutlined,
} from "@ant-design/icons";

import "./styles.scss";

import moment from "moment";
import {
  getData,
  editItem,
  addItem,
  deleteItem,
  updateItem,
} from "../../../Redux/actions/crudActions";
import { getProductInventory } from "../../../Redux/actions/inventoryActions";
import { toggleDirectShip } from "../../../Redux/actions/productActions";

import { errorParser } from "../../../utils/helpers";
import { numberWithCommas } from "../../../utils/helpers";

import CreateForm from "../../Generic/CreateForm";
import ProductInventoryChange from "../ProductInventoryChange";

const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;

const Index = ({ currentItem, somethingChanged, refresh }) => {
  const dispatch = useDispatch();
  const { user, locations } = useSelector(
    (state) => ({
      user: state.auth.user,
      locations: state.locations.locations,
    }),
    shallowEqual
  );

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    if (currentItem) {
      console.log("currentItem", currentItem);
      if (currentItem.id) {
        retrieveprods();
      }
    }
  }, [currentItem]);

  useEffect(() => {
    if (currentItem) {
      if (currentItem.id) {
        retrieveprods();
      }
    }
  }, [refresh]);

  const retrieveprods = () => {
    dispatch(getProductInventory(currentItem.id))
      .then((res) => {
        var docs = res.docs;
        var dataArray = [];

        docs.map((item) => {
          var newOrder = {
            key: item.id,
            id: item.id,
            ...item.data(),
          };
          dataArray.push(newOrder);
        });
        createData(dataArray);
      })
      .catch((err) => {});
  };

  const createData = (invn) => {
    var madeData = [];
    var filteredLocations = [];
    if (user.role == "admin" || user.role == "manager") {
      filteredLocations = locations;
    } else {
      filteredLocations = locations.filter(
        (locitem) => locitem.id == user.branch
      );
    }
    filteredLocations.map((loc) => {
      var item = {
        id: null,
        location: loc.id,
        location_name: loc.name,
        product: currentItem.id,
        product_name: currentItem.name,
        quantity: 0,
        restock: 0,
        doRestock: "",
      };
      var filteredinvt = invn.filter((invitem) => invitem.location == loc.id);
      if (filteredinvt[0]) {
        var exsisting = filteredinvt[0];
        item["id"] = exsisting.id;
        item["quantity"] = exsisting.quantity;
        item["restock"] = exsisting.restock;
      }
      if (item.restock > 0) {
        if (parseFloat(item.quantity) < parseFloat(item.restock) * 1.25) {
          item["doRestock"] = "NEAR";
        }
        if (parseFloat(item.quantity) <= parseFloat(item.restock)) {
          item["doRestock"] = "RESTOCK";
        }
        if (parseFloat(item.quantity) > parseFloat(item.restock) * 1.25) {
          item["doRestock"] = "GOOD";
        }
      } else {
        item["doRestock"] = "X";
      }

      madeData.push(item);
    });

    setData(madeData);
  };

  var columns = [
    {
      title: "Location",
      dataIndex: "location_name",
      key: "location_name",
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
      render: (text, record, index) => {
        return (
          <Tooltip
            title={
              <div className="vertical">
                <div>{`${numberWithCommas(parseFloat(text).toFixed(2))} ${
                  currentItem.unit
                }`}</div>
                {currentItem.second_unit_rate &&
                currentItem.second_unit &&
                parseFloat(currentItem.second_unit_rate) > 0 ? (
                  <div>{`${numberWithCommas(
                    (
                      parseFloat(text) *
                      parseFloat(currentItem.second_unit_rate)
                    ).toFixed(2)
                  )} ${currentItem.second_unit}`}</div>
                ) : null}
              </div>
            }
          >
            {numberWithCommas(parseFloat(text).toFixed(2))}
          </Tooltip>
        );
      },
    },
    {
      title: "Restock Level",
      dataIndex: "restock",
      key: "restock",
      // render: (text, record, index) =>{
      //   return (
      //     text
      //   );
      // }
    },
    {
      title: "Restock",
      dataIndex: "doRestock",
      key: "doRestock",
      sorter: (a, b) => a.doRestock.localeCompare(b.doRestock),

      render: (text, record, index) => {
        if (text == "RESTOCK") {
          return <Tag color="red">RESTOCK</Tag>;
        } else if (text == "NEAR") {
          return <Tag color="yellow">NEAR</Tag>;
        } else if (text == "GOOD") {
          return <Tag color="green">GOOD</Tag>;
        } else {
          return <Tag color="#d4d1cb">N/A</Tag>;
        }
      },
    },

    {
      title: "Direct Ship",
      dataIndex: "direct_ship",
      key: "direct_ship",

      render: (text, record, index) => {
        var defaultChecked = false;
        if (currentItem?.direct_ship) {
          if (currentItem.direct_ship.includes(record.location)) {
            defaultChecked = true;
          }
        }

        return (
          <Switch
            defaultChecked={defaultChecked}
            onChange={(e) => {
              dispatch(toggleDirectShip(currentItem.id, e, record.location));
            }}
            size={"small"}
          />
        );
      },
    },
  ];

  const colfilter = () => {
    var cols = columns;
    var editcol = [
      {
        title: "",

        render: (text, record, index) => {
          return (
            <ProductInventoryChange
              currentItem={record}
              currentProduct={currentItem}
              onModalClose={(e) => {
                if (e == "refresh") {
                  somethingChanged(true);
                  retrieveprods();
                }
              }}
            />
          );
        },
      },
    ];

    if (user.role == "admin" || user.role == "manager") {
      cols = columns.concat(editcol);
    }

    return cols;
  };

  return (
    <div className={"productInventoryTable"}>
      <Table
        className={"inventoryTable"}
        columns={colfilter()}
        dataSource={data}
        pagination={false}
        width={"100%"}
        size={"small"}
      />
    </div>
  );
};

export default Index;
